var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 28.3652V32.3652C17.706 32.3652 12.3334 37.7378 12.3334 44.3652H8.33337C8.33337 35.5286 15.4968 28.3652 24.3334 28.3652ZM24.3334 26.3652C17.7034 26.3652 12.3334 20.9952 12.3334 14.3652C12.3334 7.73523 17.7034 2.36523 24.3334 2.36523C30.9634 2.36523 36.3334 7.73523 36.3334 14.3652C36.3334 20.9952 30.9634 26.3652 24.3334 26.3652ZM24.3334 22.3652C28.7534 22.3652 32.3334 18.7852 32.3334 14.3652C32.3334 9.94523 28.7534 6.36523 24.3334 6.36523C19.9134 6.36523 16.3334 9.94523 16.3334 14.3652C16.3334 18.7852 19.9134 22.3652 24.3334 22.3652ZM36.3334 43.3652L30.4556 46.4554L31.5782 39.9102L26.8228 35.275L33.3944 34.3202L36.3334 28.3652L39.2724 34.3202L45.844 35.275L41.0886 39.9102L42.2112 46.4554L36.3334 43.3652Z",
    fill: "#3940A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonStar);
export default __webpack_public_path__ + "static/media/PersonStar.6153755ce3b3779d4fb64f954167fc03.svg";
export { ForwardRef as ReactComponent };